/* Handyman Advertorial sections (ha-*): sticky CTA + post date. */
(function () {
  if (window.__haInit) return;
  window.__haInit = true;

  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Post date: today + N days (N is negative for "days ago"), in the visitor's calendar so cached pages stay current */
  function updateDates() {
    qsa('[data-ha-date]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + Number(el.dataset.haDays || 0));
      try {
        el.textContent = d.getDate() + ' ' + d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + d.getFullYear();
      } catch (err) { /* keep the server-rendered date */ }
    });
  }

  /* Sticky CTA: shown while the headline and both buttons are all off screen, like the design */
  var io = null;
  var visible = new Set();
  function setBars() {
    var show = visible.size === 0;
    qsa('[data-ha-sticky]').forEach(function (bar) {
      if (bar.hasAttribute('data-ha-preview')) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      qsa('a,button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    });
  }
  function watch() {
    if (io) io.disconnect();
    visible.clear();
    var targets = qsa('[data-ha-watch]');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      setBars();
    });
    targets.forEach(function (t) { io.observe(t); });
  }

  function init() {
    updateDates();
    watch();
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
